export const MESSAGE_TEMPLATE_VARIABLES = [
  'lead_nome',
  'lead_telefone',
  'lead_email',
  'evento_descricao',
  'evento_data',
  'evento_local',
  'venda_total',
  'fotografo',
  'estudio',
] as const;

export type MessageTemplateVariable = (typeof MESSAGE_TEMPLATE_VARIABLES)[number];

export function renderMessageTemplate(
  body: string,
  vars: Record<string, string | undefined>,
): string {
  return body.replace(/\{\{([^}]+)\}\}/g, (_match, rawKey: string) => {
    const key = rawKey.trim();
    return vars[key] ?? '';
  });
}
